<script lang="ts">
  import { convertToDistributorDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { HappyHourDeal, HappyHourDealDistributor } from "@shared/types/Deals";

  export let deal: HappyHourDeal;
  export let distributor: HappyHourDealDistributor;
  export let openModal: () => void;
  export let startDate: string = null;
  export let endDate: string = null;

  const distributorUrl = () => {
    if (distributor.has_storefront) {
      return `/storefront/${distributor.id}`;
    } else {
      return `/?distributors=${distributor.id}`;
    }
  };
</script>

<section data-grid-area="header">
  <div class="fizz-flex-row">
    <div class="fizz-flex-item fizz-space-between-responsive">
      <div class="fizz-flex-item fizz-text-medium">
        <h4 class="fizz-heading-4 fizz-stack-8">{deal.displayName}</h4>
        <div class="fizz-flex-row-8-responsive">
          <div class="fizz-flex-row-8">
            <Icon width="16" height="16" type="DistributorName" className="fizz-icon-16" />
            <a href={distributorUrl()} class="fizz-inline-16">
              {distributor.name}
            </a>
          </div>
          {#if endDate}
            <div class="fizz-flex-row-8 deal-date">
              <Icon type="Clock" />
              {#if Date.parse(endDate) < Date.now()}
                <span class="fizz-text-urgent">
                  Expired {convertToDistributorDate(endDate)}
                </span>
              {:else if Date.parse(startDate) > Date.now()}
                <span>
                  Begins on {convertToDistributorDate(startDate)}
                </span>
              {:else}
                <span>
                  Expires {convertToDistributorDate(endDate)}
                </span>
              {/if}
            </div>
          {/if}
        </div>
      </div>
      <div class="fizz-flex-row">
        <button
          class="fizz-button-small fizz-button-icon fizz-button"
          on:click|preventDefault={openModal}
        >
          <Icon width="16" height="16" type="Info" className="fizz-icon-16" />
          <span>About this deal</span>
        </button>
      </div>
    </div>
  </div>
</section>
